import axios from '@axios'

// счётчик запросов фильтров сверки: применяем только самый свежий ответ,
// чтобы медленный старый запрос не перезаписал актуальный список
let filtersRequestSeq = 0

export default {
  namespaced: true,
  state: {
    revise_file: null,
    museum_objects: [],
    filter_objects: [],
    filters_loading: false,
    request_is_sending: false,
    request_is_success: null,
    request_error_msg: null,
  },
  getters: {
    getFile: state => state.revise_file,
    getAllMuseumObjects: state => state.museum_objects,
    getFilterObjects: state => state.filter_objects,
    getFiltersLoading: state => state.filters_loading,
    getRequestStatus: state => state.request_is_success,
    getRequestErrorMsg: state => state.request_error_msg,
    getRequestIsSending: state => state.request_is_sending,
  },
  mutations: {
    init_revise(state) {
      state.revise_file = null
      state.request_is_sending = false
      state.request_is_success = null
      state.request_error_msg = null
    },
    set_request_init(state) {
      state.revise_file = null
      state.request_is_sending = true
      state.request_is_success = null
      state.request_error_msg = null
    },
    revise_request_success(state, data) {
      state.revise_file = data
      state.request_is_sending = false
      state.request_is_success = true
      state.request_error_msg = null
    },
    revise_request_error(state, errorMsg) {
      state.revise_file = null
      state.request_is_sending = false
      state.request_is_success = false
      state.request_error_msg = errorMsg
    },
    museum_objects_request_success(state, payload) {
      state.museum_objects = payload
    },
    revise_filters_loading(state) {
      state.filters_loading = true
    },
    revise_filters_success(state, payload) {
      state.filter_objects = payload
      state.filters_loading = false
    },
  },
  actions: {
    // объекты (с музеями), по которым у клиента есть заявки за период
    fetchReviseFilters({ commit }, periodFilter) {
      filtersRequestSeq += 1
      const seq = filtersRequestSeq
      commit('revise_filters_loading')

      return new Promise(resolve => {
        const data = JSON.stringify({
          period_lower: periodFilter.period_lower,
          period_upper: periodFilter.period_upper,
          language: 'ru',
        })
        const postData = new FormData()
        postData.append('data', data)
        postData.append('action', 'revise_filters')
        axios({
          method: 'post',
          url: '/api/v1/actions/',
          data: postData,
          headers: { 'Content-Type': 'multipart/form-data' },
          responseType: 'json',
        })
          .then(response => {
            // устаревший ответ (уже ушёл более свежий запрос) — игнорируем
            if (seq !== filtersRequestSeq) {
              resolve(null)

              return
            }
            const payload = response.status === 200 && response.data.success !== false ? response.data.data : []
            commit('revise_filters_success', payload)
            resolve(payload)
          })
          .catch(() => {
            if (seq === filtersRequestSeq) {
              commit('revise_filters_success', [])
            }
            resolve(null)
          })
      })
    },
    fetchAllMuseumObjects({ commit }) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/v1/museums-objects/',
        })
          .then(response => {
            if (response.status === 200) {
              commit('museum_objects_request_success', response.data)
              resolve(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getReviseRequest({ commit }, reviseFilter) {
      commit('set_request_init')

      return new Promise((resolve, reject) => {
        const data = JSON.stringify({
          museum_id: reviseFilter.museum_id,
          period_lower: reviseFilter.period_lower,
          period_upper: reviseFilter.period_upper,
        })
        const postData = new FormData()
        postData.append('data', data)
        postData.append('action', 'revise')
        axios({
          method: 'post',
          url: '/api/v1/actions/',
          data: postData,
          headers: { 'Content-Type': 'multipart/form-data' },

          responseType: 'blob',
        })
          .then(responseBlob => {
            const reader = new FileReader()

            reader.onload = () => {
              let response = { status: true, message: '' }

              try {
                response = JSON.parse(reader.result)
                // eslint-disable-next-line no-empty
              } catch (e) {}

              if (response.success === false) {
                commit(
                  'revise_request_error',
                  response.error === 'Период превышает 3 месяца'
                    ? `${response.error} или неверно выбраны даты`
                    : response.error,
                )
              } else {
                commit('revise_request_success', responseBlob.data)
              }
            }
            reader.readAsText(responseBlob.data)
          })
          .catch(error => reject(error))
      })
    },
  },
}
